import { ASSESSMENT } from '@src/module/Assessment/constants/api'

export const LOGS_ASSESSMENT = `/logs${ASSESSMENT}` as const
export const LOGS_ASSESSMENT_AUDIT = `${LOGS_ASSESSMENT}audit` as const
export const LOGS_ASSESSMENT_STUDENT_LIST = `${LOGS_ASSESSMENT}student-list` as const
export const LOGS_ASSESSMENT_STUDENT_SUBMISSIONS = `${LOGS_ASSESSMENT}student/submissions` as const
